module.exports = __webpack_public_path__ + "static/img/room1.0a21065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room1.png
// module id = l44/
// module chunks = 0